import { useGeneralContext } from '@context/GeneralContext';
import { useState, useEffect } from 'react';

const useOnlineStatus = () => {
    const [isOnline, setIsOnline] = useState(null);
    const GET_HEALTH = import.meta.env[
        `VITE_REACT_APP_ENDPOINT_HEALTH_${import.meta.env.MODE}`
    ];
    const checkOnlineStatus = async () => {
        try {
            await fetch(GET_HEALTH, {
                method: 'GET',
                mode: 'no-cors'
            });
            setIsOnline(true);
            return true
        } catch (error) {
            setIsOnline(false);
            return false
        }
    };

    useEffect(() => {
        // Initial check
        checkOnlineStatus();
    }, []);

    return [isOnline, checkOnlineStatus];
};

export default useOnlineStatus;
